import { fromJS } from 'immutable';
import { fromPairs, map } from 'lodash-es';

import * as types from './actionTypes';
import initialState from '../../Store/initialState';

import { locale } from '../Tools/reducers';
import * as systemTypes from '../System/actionTypes';

import { getContractList, getReducedContract, appendContractList } from './transform';

let newState;
let newContract;

const contracts = (state = initialState.get('contracts'), action) => {
  try {
    switch (action.type) {
      // LOCALE
      case systemTypes.FETCH_USER_LANGUAGE: {
        return state.set('strings', locale(action?.data?.language, 'contracts'));
      }

      // FETCH CONTRACTS
      case types.FETCH_CONTRACTS_REQUEST: {
        newState = state.setIn(['loading', 'isLoadingContracts'], true);
        return newState;
      }
      case types.FETCH_CONTRACTS_SUCCESS: {
        newState = state.mergeDeep(
          state,
          fromJS({
            contracts: fromPairs(map(action.data?.contracts, i => [i.id, i])),
            list: getContractList(action.data?.contracts),
            currentOffset: action.offset
          })
        );
        newState = newState.setIn(['loading', 'isLoadingContracts'], false);
        return newState;
      }

      case types.FETCH_CONTRACTS_FAIL: {
        newState = state.mergeDeep(
          state,
          fromJS({
            contracts: [],
            list: [],
          })
        );
        newState = newState.setIn(['loading', 'isLoadingContracts'], false);
        newState = newState.setIn(
          ['alerts', 'errors'],
          fromJS([{ t: Date.now(), msg: Array.isArray(action.error) ? action.error[0] : action.error }])
        );
        return newState;
      }

      // FETCH CONTRACT
      case types.FETCH_CONTRACT_REQUEST: {
        newState = state.setIn(['loading', 'isLoadingContract'], true);
        return newState;
      }

      case types.FETCH_CONTRACT_SUCCESS: {
        // set/update contract in store
        newContract = fromJS(
          getReducedContract({
            nextContract: action.data.contracts[0],
            prevContract: state.getIn(['contracts', String(action.id)]),
          })
        );
        newContract = state.getIn(['contracts', String(action.data?.contracts[0]?.contractNumber)])
          ? state.getIn(['contracts', String(action.data?.contracts[0]?.contractNumber)]).mergeDeep(newContract)
          : newContract;
        newState = state.setIn(['contracts', String(action.data?.contracts[0].contractNumber)], fromJS(newContract));
        newState = newState.setIn(['loading', 'isLoadingContract'], false);
        return newState;
      }

      case types.FETCH_CONTRACT_FAIL: {
        newState = state.setIn(['contracts', String(action.id)], undefined);
        newState = newState.setIn(['loading', 'isLoadingContract'], false);
        newState = newState.setIn(
          ['alerts', 'errors'],
          fromJS([{ t: Date.now(), msg: Array.isArray(action.error) ? action.error[0] : action.error }])
        );
        return newState;
      }

      // LOAD MORE PARTIES
      case types.LOAD_MORE_CONTRACTS_REQUEST: {
        newState = state.setIn(['loading', 'isLoadingContracts'], true);
        return newState;
      }

      case types.LOAD_MORE_CONTRACTS_SUCCESS: {
        newState = state.mergeDeep(
          state,
          fromJS({
            contracts: fromPairs(map(action.data?.contracts, i => [i.id, i])),
            list: appendContractList(state.getIn(['list']), action.data?.contracts),
            currentOffset: action?.offset
          })
        );

        newState = newState.setIn(['loading', 'isLoadingParties'], false);
        return newState;
      }

      case types.LOAD_MORE_CONTRACTS_FAIL: {
        newState = state.mergeDeep(
          state,
          fromJS({
            contracts: [],
            list: [],
          })
        );
        newState = newState.setIn(['loading', 'isLoadingContracts'], false);
        newState = newState.setIn(
          ['alerts', 'errors'],
          fromJS([{ t: Date.now(), msg: Array.isArray(action.error) ? action.error[0] : action.error }])
        );
        return newState;
      }

      // FETCH QUOTE
      case types.FETCH_QUOTE_REQUEST: {
        newState = state.setIn(['loading', 'isLoadingContract'], true);
        return newState;
      }

      case types.FETCH_QUOTE_SUCCESS: {
        // set/update contract in store
        newContract = fromJS(
          getReducedContract({
            nextContract: action.data.quotes[0],
            prevContract: state.getIn(['contracts', String(action.id)]),
          })
        );
        newContract = state.getIn(['contracts', String(action.data?.quotes[0]?.quoteNumber)])
          ? state.getIn(['contracts', String(action.data?.quotes[0]?.quoteNumber)]).mergeDeep(newContract)
          : newContract;
        newState = state.setIn(['contracts', String(action.data?.quotes[0].quoteNumber)], fromJS(newContract));
        newState = newState.setIn(['loading', 'isLoadingContract'], false);
        return newState;
      }

      case types.FETCH_QUOTE_FAIL: {
        newState = state.setIn(['contracts', String(action.id)], undefined);
        newState = newState.setIn(['loading', 'isLoadingContract'], false);
        newState = newState.setIn(
          ['alerts', 'errors'],
          fromJS([{ t: Date.now(), msg: Array.isArray(action.error) ? action.error[0] : action.error }])
        );
        return newState;
      }

      // FETCH CONTRACT EVENTS
      case types.FETCH_CONTRACT_EVENTS_REQUEST: {
        newState = state.setIn(['loading', 'isLoadingContractEvents'], true);
        return newState;
      }

      case types.FETCH_CONTRACT_EVENTS_SUCCESS: {
        // set/update contract in store
        newContract = fromJS({ events: action.data });
        newContract = state.getIn(['contracts', String(action.id)])
          ? state.getIn(['contracts', String(action.id)]).mergeDeep(newContract)
          : newContract;
        newState = state.setIn(['contracts', String(action.id)], newContract);
        newState = newState.setIn(['loading', 'isLoadingContractEvents'], false);
        return newState;
      }

      case types.FETCH_CONTRACT_EVENTS_FAIL: {
        newState = state.setIn(['contracts', String(action.id), 'events'], undefined);
        newState = newState.setIn(['loading', 'isLoadingContractEvents'], false);
        newState = newState.setIn(
          ['alerts', 'errors'],
          fromJS([{ t: Date.now(), msg: Array.isArray(action.error) ? action.error[0] : action.error }])
        );
        return newState;
      }

      // FETCH CONTRACT DOCUMENTS
      case types.FETCH_CONTRACT_DOCUMENTS_REQUEST: {
        newState = state.setIn(['loading', 'isLoadingContractDocuments'], true);
        return newState;
      }

      case types.FETCH_CONTRACT_DOCUMENTS_SUCCESS: {
        // set/update contract in store
        newContract = fromJS({ documents: action.data });
        newContract = state.getIn(['contracts', String(action.id)])
          ? state.getIn(['contracts', String(action.id)]).mergeDeep(newContract)
          : newContract;
        newState = state.setIn(['contracts', String(action.id)], newContract);
        newState = newState.setIn(['loading', 'isLoadingContractDocuments'], false);
        return newState;
      }

      case types.FETCH_CONTRACT_DOCUMENTS_FAIL: {
        newState = state.setIn(['contracts', String(action.id), 'documents'], undefined);
        newState = newState.setIn(['loading', 'isLoadingContractDocuments'], false);
        newState = newState.setIn(
          ['alerts', 'errors'],
          fromJS([{ t: Date.now(), msg: Array.isArray(action.error) ? action.error[0] : action.error }])
        );
        return newState;
      }

      // FETCH CONTRACT ATTACHMENTS
      case types.FETCH_CONTRACT_ATTACHMENTS_REQUEST: {
        newState = state.setIn(['loading', 'isLoadingContractAttachments'], true);
        return newState;
      }

      case types.FETCH_CONTRACT_ATTACHMENTS_SUCCESS: {
        // set/update contract in store
        newContract = fromJS({ attachments: action.data });
        newContract = state.getIn(['contracts', String(action.id)])
          ? state.getIn(['contracts', String(action.id)]).mergeDeep(newContract)
          : newContract;
        newState = state.setIn(['contracts', String(action.id)], newContract);
        newState = newState.setIn(['loading', 'isLoadingContractAttachments'], false);
        return newState;
      }

      case types.FETCH_CONTRACT_ATTACHMENTS_FAIL: {
        newState = state.setIn(['contracts', String(action.id), 'attachments'], undefined);
        newState = newState.setIn(['loading', 'isLoadingContractAttachments'], false);
        newState = newState.setIn(
          ['alerts', 'errors'],
          fromJS([{ t: Date.now(), msg: Array.isArray(action.error) ? action.error[0] : action.error }])
        );
        return newState;
      }

      // FETCH CONTRACT BENEFICIARIES
      case types.FETCH_CONTRACT_BENEFICIARIES_REQUEST: {
        newState = state.setIn(['loading', 'isLoadingContractBeneficiaries'], true);
        return newState;
      }

      case types.FETCH_CONTRACT_BENEFICIARIES_SUCCESS: {
        // set/update contract in store
        newContract = fromJS({ beneficiaries: action.data });
        newContract = state.getIn(['contracts', String(action.id)])
          ? state.getIn(['contracts', String(action.id)]).mergeDeep(newContract)
          : newContract;
        newState = state.setIn(['contracts', String(action.id)], newContract);
        newState = newState.setIn(['loading', 'isLoadingContractBeneficiaries'], false);
        return newState;
      }

      case types.FETCH_CONTRACT_BENEFICIARIES_FAIL: {
        newState = state.setIn(['contracts', String(action.id), 'beneficiaries'], undefined);
        newState = newState.setIn(['loading', 'isLoadingContractBeneficiaries'], false);
        newState = newState.setIn(
          ['alerts', 'errors'],
          fromJS([{ t: Date.now(), msg: Array.isArray(action.error) ? action.error[0] : action.error }])
        );
        return newState;
      }

      // FETCH CONTRACT NOTES
      case types.FETCH_CONTRACT_NOTES_REQUEST: {
        newState = state.setIn(['loading', 'isLoadingContractNotes'], true);
        return newState;
      }

      case types.FETCH_CONTRACT_NOTES_SUCCESS: {
        // set/update contract in store
        newContract = fromJS({ notes: action.data });
        newContract = state.getIn(['contracts', String(action.id)])
          ? state.getIn(['contracts', String(action.id)]).mergeDeep(newContract)
          : newContract;
        newState = state.setIn(['contracts', String(action.id)], newContract);
        newState = newState.setIn(['loading', 'isLoadingContractNotes'], false);
        return newState;
      }

      case types.FETCH_CONTRACT_NOTES_FAIL: {
        newState = state.setIn(['contracts', String(action.id), 'notes'], undefined);
        newState = newState.setIn(['loading', 'isLoadingContractNotes'], false);
        newState = newState.setIn(
          ['alerts', 'errors'],
          fromJS([{ t: Date.now(), msg: Array.isArray(action.error) ? action.error[0] : action.error }])
        );
        return newState;
      }

      // FETCH QUOTATION STATUS
      case types.FETCH_CONTRACT_STATUS_REQUEST: {
        newState = state.setIn(['loading', 'isLoadingContractStatus'], true);
        return newState;
      }

      case types.FETCH_CONTRACT_STATUS_SUCCESS: {
        newState = state.mergeDeep(
          state,
          fromJS({
            contractStatus: action.data.desc,
          })
        );
        newState = newState.setIn(['loading', 'isLoadingContractStatus'], false);
        return newState;
      }

      case types.FETCH_CONTRACT_STATUS_FAIL: {
        newState = state.mergeDeep(
          state,
          fromJS({
            contractStatus: [],
          })
        );
        newState = newState.setIn(['loading', 'isLoadingContractStatus'], false);
        newState = newState.setIn(
          ['alerts', 'errors'],
          fromJS([{ t: Date.now(), msg: Array.isArray(action.error) ? action.error[0] : action.error }])
        );
        return newState;
      }

      // ADD CONTRACT DOCUMENT
      case types.ADD_CONTRACT_DOCUMENT_REQUEST: {
        newState = state.setIn(['loading', 'isUpdatingContractDocuments'], true);
        return newState;
      }

      case types.ADD_CONTRACT_DOCUMENT_SUCCESS: {
        newState = state.setIn(['loading', 'isUpdatingContractDocuments'], false);
        return newState;
      }

      case types.ADD_CONTRACT_DOCUMENT_FAIL: {
        newState = state.setIn(['loading', 'isUpdatingContractDocuments'], false);
        newState = newState.setIn(
          ['alerts', 'errors'],
          fromJS([{ t: Date.now(), msg: Array.isArray(action.error) ? action.error[0] : action.error }])
        );
        return newState;
      }

      // DELETE CONTRACT DOCUMENT
      case types.DELETE_CONTRACT_DOCUMENT_REQUEST: {
        newState = state.setIn(['loading', 'isDeletingContractDocuments'], true);
        return newState;
      }

      case types.DELETE_CONTRACT_DOCUMENT_SUCCESS: {
        newState = state.setIn(['loading', 'isDeletingContractDocuments'], false);
        return newState;
      }

      case types.DELETE_CONTRACT_DOCUMENT_FAIL: {
        newState = state.setIn(['loading', 'isDeletingContractDocuments'], false);
        newState = newState.setIn(
          ['alerts', 'errors'],
          fromJS([{ t: Date.now(), msg: Array.isArray(action.error) ? action.error[0] : action.error }])
        );
        return newState;
      }

      // SUBMIT_QUOTE (ACTIVATE CONTRACT)
      case types.SUBMIT_QUOTE_REQUEST: {
        newState = state.setIn(['loading', 'isSubmittingContract'], true);
        return newState;
      }

      case types.SUBMIT_QUOTE_SUCCESS: {
        // set/update contract in store
        newContract = fromJS(
          getReducedContract({
            nextContract: action.data,
            prevContract: state.getIn(['contracts', String(action.id)]),
          })
        );
        newContract = state.getIn(['contracts', String(action.id)])
          ? state.getIn(['contracts', String(action.id)]).mergeDeep(newContract)
          : newContract;
        newState = state.setIn(['contracts', String(action.id)], fromJS(newContract));
        newState = newState.setIn(['alerts', 'infos'], fromJS(['Activation Ok']));
        newState = newState.setIn(['loading', 'isSubmittingContract'], false);
        return newState;
      }

      case types.SUBMIT_QUOTE_FAIL: {
        newState = state.setIn(['loading', 'isSubmittingContract'], false);
        newState = newState.setIn(
          ['alerts', 'errors'],
          fromJS([{ t: Date.now(), msg: Array.isArray(action.error) ? action.error[0] : action.error }])
        );
        return newState;
      }

      // CRYPTO CHECK
      case types.CRYPTOLOG_CHECK_REQUEST: {
        newState = state.setIn(['loading', 'isCryptoLogChecking'], true);
        return newState;
      }

      case types.CRYPTOLOG_CHECK_SUCCESS: {
        // set/update survey in store
        newState = newState.setIn(['alerts', 'successes'], fromJS([{ t: Date.now(), msg: 'ok' }]));
        newState = state.setIn(['loading', 'isCryptoLogChecking'], false);
        return newState;
      }

      case types.CRYPTOLOG_CHECK_FAIL: {
        newState = state.setIn(['loading', 'isCryptoLogChecking'], false);
        newState = newState.setIn(
          ['alerts', 'errors'],
          fromJS([{ t: Date.now(), msg: Array.isArray(action.error) ? action.error[0] : action.error }])
        );
        return newState;
      }

      // CRYPTO SIGN
      case types.CRYPTOLOG_SIGN_REQUEST: {
        newState = state.setIn(['loading', 'isCryptoLogSigning'], true);
        return newState;
      }

      case types.CRYPTOLOG_SIGN_SUCCESS: {
        // set/update survey in store
        newState = newState.setIn(['alerts', 'successes'], fromJS([{ t: Date.now(), msg: 'ok' }]));
        newState = state.setIn(['loading', 'isCryptoLogSigning'], false);
        return newState;
      }

      case types.CRYPTOLOG_SIGN_FAIL: {
        newState = state.setIn(['loading', 'isCryptoLogSigning'], false);
        newState = newState.setIn(
          ['alerts', 'errors'],
          fromJS([{ t: Date.now(), msg: Array.isArray(action.error) ? action.error[0] : action.error }])
        );
        return newState;
      }

      // DOWNLOAD ATTACHMENT
      case types.DOWNLOAD_ATTACHMENT_REQUEST: {
        newState = state.setIn(['loading', 'isDownloadingAttachment'], true);
        return newState;
      }
      case types.DOWNLOAD_ATTACHMENT_SUCCESS: {
        newState = state.mergeDeep(
          state,
          fromJS({
            attachmentData: action.data
          })
        );
        return newState;
      }
      case types.DOWNLOAD_ATTACHMENT_FAIL: {
        newState = state.setIn(['loading', 'isDownloadingAttachment'], false);
        newState = newState.setIn(
          ['alerts', 'errors'],
          fromJS([{ t: Date.now(), msg: Array.isArray(action.error) ? action.error[0] : action.error }])
        );
        return newState;
      }

      // UPDATE DOCUMENT REQUEST LINE
      case types.UPDATE_DOCUMENT_REQUEST_LINE_REQUEST: {
        newState = state.setIn(['loading', 'isUpdatingContractDocuments'], true);
        newState = newState.setIn(['alerts', 'errors'], fromJS([]));
        newState = newState.setIn(['alerts', 'successes'], fromJS([]));
        return newState;
      }

      case types.UPDATE_DOCUMENT_REQUEST_LINE_SUCCESS: {
        newState = state.setIn(['loading', 'isUpdatingContractDocuments'], false);
        newState = newState.setIn(['alerts', 'errors'], fromJS([]));
        newState = newState.setIn(
          ['alerts', 'successes'],
          fromJS([{ t: Date.now(), msg: 'contract.alert.document_upload.success' }])
        );
        return newState;
      }

      case types.UPDATE_DOCUMENT_REQUEST_LINE_FAIL: {
        newState = state.setIn(['loading', 'isUpdatingContractDocuments'], false);
        newState = newState.setIn(['alerts', 'successes'], fromJS([]));
        newState = newState.setIn(
          ['alerts', 'errors'],
          fromJS([{ t: Date.now(), msg: Array.isArray(action.error) ? action.error[0] : action.error }])
        );
        return newState;
      }
      default:
        return state;
    }
  } catch (e) {
    console.log(e.stack);
    return state;
  }
};
export default contracts;
